export default {"src":"/_next/static/media/ValidityInactive.3aecc87a.svg","height":22,"width":30,"blurWidth":0,"blurHeight":0};